import z from 'zod';

export const warningPatternSchema = z
  .object({
    name: z.string().optional(),
    surname: z.string().optional(),
    email: z
      .string()
      .email('Invalid email address')
      .optional()
      .or(z.literal('')),
    type: z.boolean(),
  })
  .refine(
    (data) => {
      const hasNameOrSurname =
        (data.name && data.name.trim()) ||
        (data.surname && data.surname.trim());
      const hasEmail = data.email && data.email.trim();
      return hasNameOrSurname || hasEmail;
    },
    {
      message: 'Either name/surname or email is required',
      path: ['email'],
    },
  )
  .refine(
    (data) => {
      const hasNameOrSurname =
        (data.name && data.name.trim()) ||
        (data.surname && data.surname.trim());
      const hasEmail = data.email && data.email.trim();
      return !(hasNameOrSurname && hasEmail);
    },
    {
      message: 'Cannot have both name/surname and email',
      path: ['email'],
    },
  );

export type WarningPatternFormValues = z.infer<typeof warningPatternSchema>;
